import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  container: {
    display: 'flex',
    borderRadius: '2px',
    backgroundColor: palette.shades[200],
    justifyContent: 'center',
    border: "1px solid ".concat(palette.shades[300]),
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    fontFamily: palette.fontFamilies.poppins,
    minWidth: '150px',
    maxWidth: '190px',
    '&.defaultPortfolio': {
      maxWidth: '165px'
    },
    height: '36px',
    padding: '6px 4px',
    alignItems: 'center',
    marginBottom: '4px',
    marginLeft: '4px',
    '&.loaderPlaceholder': {
      padding: 'unset'
    }
  },
  icon: {
    display: 'flex',
    flexShrink: '0',
    marginRight: '8px',
    borderRadius: '2px',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    justifyContent: 'center',
    width: '24px',
    height: '24px'
  },
  labelData: {
    width: '100%',
    alignItems: 'center',
    textAlign: 'left',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    margin: '0px 4px',
    lineHeight: '14px',
    minHeight: 'unset',
    cursor: 'default'
  }
});
export default useStyles;